import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import LoadingSpinner from '../components/LoadingSpinner';

const MiroWhiteboardPage = () => {
  const { boardId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the new hybrid whiteboard experience
    if (boardId) {
      navigate(`/whiteboard/${boardId}?mode=miro`, { replace: true });
    } else {
      navigate('/boards', { replace: true });
    }
  }, [boardId, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <LoadingSpinner size="large" />
        <p className="text-gray-600 mt-4">Redirecting to Hybrid Whiteboard...</p>
      </div>
    </div>
  );
};

export default MiroWhiteboardPage; 